"use strict";

var TwoBitFile = require('./twoBitFile');

module.exports = {
  TwoBitFile: TwoBitFile
};